var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.9923V15.8608C4.5 16.2956 4.65804 16.7125 4.93934 17.0199C5.22064 17.3273 5.60218 17.5 6 17.5H15C15.3978 17.5 15.7794 17.3273 16.0607 17.0199C16.342 16.7125 16.5 16.2956 16.5 15.8608V12.9923M10.5007 3.5L10.5007 12.7886M10.5007 12.7886L7.07213 9.23947M10.5007 12.7886L13.9293 9.23947",
    stroke: "#33363F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.c4712138aab2eb29ba053c4a895c1232.svg";
export { ForwardRef as ReactComponent };